import { UserProperties } from '@generated/userProperties';

import { getAmplitudeInstance } from './getAmplitudeInstance';

export function setUserProperties(properties: UserProperties): void {
  getAmplitudeInstance()?.setUserProperties(properties);
}
